import { 
    Stack, 
    TextField, 
    MenuItem, 
    IconButton, 
    Button, 
} from "@mui/material";
import { Add, DeleteOutline } from "@mui/icons-material";


const CrewEditor = ({ rows, availableCrew = [], onUpdate, onAdd, onRemove }) => {
    const unpicked    = availableCrew.filter((m) => !rows.some((r) => r.crewCode === m.crewCode));
    const postOptions = [...new Set(availableCrew.map((m) => m.post).filter(Boolean))].sort();
    const baseOptions = [...new Set(availableCrew.map((m) => m.base).filter(Boolean))].sort();

    return (
        <>
            {rows?.map((row, idx) => (
                <Stack
                    key={idx}
                    direction="row"
                    alignItems="center"
                    flexWrap="wrap"
                    spacing={1}
                    mb={1}
                >
                    <TextField
                        size="small"
                        label="Code"
                        value={row.crewCode}
                        onChange={(e) => onUpdate(idx, "crewCode", e.target.value.toUpperCase())}
                        sx={{ width: 80 }}
                    />
                    <TextField
                        size="small"
                        label="Name"
                        value={row.crewName}
                        onChange={(e) => onUpdate(idx, "crewName", e.target.value)}
                        sx={{ flex: 1, minWidth: 120 }}
                    />
                    <TextField
                        select
                        size="small"
                        label="Post"
                        value={row.post}
                        onChange={(e) => onUpdate(idx, "post", e.target.value)}
                        sx={{ width: 80 }}
                    >
                        {postOptions.map((p) => (
                            <MenuItem key={p} value={p}>{p}</MenuItem>
                        ))}
                    </TextField>
                    <TextField
                        select
                        size="small"
                        label="Base"
                        value={row.base}
                        onChange={(e) => onUpdate(idx, "base", e.target.value)}
                        sx={{ width: 80 }}
                    >
                        {baseOptions.map((b) => (
                            <MenuItem key={b} value={b}>{b}</MenuItem>
                        ))}
                    </TextField>
                    <IconButton size="small" color="error" onClick={() => onRemove(idx)}>
                        <DeleteOutline fontSize="small" />
                    </IconButton>
                </Stack>
            ))}
            <Stack direction="row" spacing={1} alignItems="center" mt={0.5}>
                {unpicked.length > 0 && (
                    <TextField
                        select
                        size="small"
                        label="Select crew member"
                        value=""
                        onChange={(e) => {
                            const m = unpicked.find((c) => c.crewCode === e.target.value);
                            if (m) onAdd(m);
                        }}
                        sx={{ flex: 1 }}
                    >
                        {unpicked.map((m) => (
                            <MenuItem key={m.crewCode} value={m.crewCode}>
                                {m.crewCode} · {m.crewName} ({m.post}{m.base ? ` / ${m.base}` : ""})
                            </MenuItem>
                        ))}
                    </TextField>
                )}
                <Button size="small" startIcon={<Add />} onClick={() => onAdd(null)}>
                    Crew Member
                </Button>
            </Stack>
        </>
    );
};

export default CrewEditor;
